<template>
  <flash-messages />
  <div class="min-h-screen bg-primary grid grid-cols-1 md:grid-cols-2">
    <div class="flex items-center justify-center relative h-32 md:min-h-full bg-center bg-cover bg-no-repeat" style="background-image: url('/images/home_professional.png')">
      <div class="bg-login-color absolute top-0 left-0 w-full h-full"></div>
    </div>
    <div class="flex items-center justify-center bg-white rounded-t-lg md:rounded-none md:rounded-l-lg min-h-full">
      <slot />
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/Fields/TextInput'
import PasswordInput from '@/Shared/Fields/PasswordInput'
import LoadingButton from '@/Shared/Components/LoadingButton'
import FlashMessages from '@/Shared/Layout/FlashMessages'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    PasswordInput,
    FlashMessages,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: 'profissional@ahlife.com.br',
        password: '123456',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>
